export default {
    debug: false,
    state: {
        eventCode: "",
        configCode: "",
        apiUri: "",
        barcode: "",
        barcodeHash: "",
        isAutoRouteToSingleAvailalbeCertificate: false,
        viewConfiguration: {
            login: {
                topHtml: "",
                bottomHtml: "",
                codeLabel: "Badgecode",
                passwordLabel: "Password",
                loginButtonLabel: "Continue"
            },
            certificateOverview: {
                topHtml: "",
                bottomHtml: "",
            },
            certificateDetail: {
                topHtml: "",
                bottomHtml: "",
            }
        }
    },
    setEventCodeAction(newValue) {
        if (this.debug) console.log('setEventCodeAction triggered with', newValue)
        this.state.eventCode = newValue;
    },
    setConfigCodeAction(newValue) {
        if (this.debug) console.log('setConfigCodeAction triggered with', newValue)
        this.state.configCode = newValue;
    },
    setApiUriAction(newValue) {
        if (this.debug) console.log('setApiUriAction triggered with', newValue)
        this.state.apiUri = newValue;
    },
    setBarcodeAction(newValue) {
        if (this.debug) console.log('setBarcodeAction triggered with', newValue)
        this.state.barcode = newValue;
    },
    setBarcodeHashAction(newValue) {
        if (this.debug) console.log('setBarcodeHashAction triggered with', newValue)
        this.state.barcodeHash = newValue;
    },    
    setisAutoRouteToSingleAvailalbeCertificate(newValue) {
        if (this.debug) console.log('setisAutoRouteToSingleAvailalbeCertificate triggered with', newValue)
        this.state.isAutoRouteToSingleAvailalbeCertificate = newValue;
    },
    setLoginViewConfigurationAction(newValue) {
        if (this.debug) console.log('setLoginViewConfigurationAction triggered with', newValue)
        this.state.viewConfiguration.login = newValue;
    },
    setCertificateOverviewViewConfigurationAction(newValue) {
        if (this.debug) console.log('setCertificateOverviewViewConfigurationAction triggered with', newValue)
        this.state.viewConfiguration.certificateOverview = newValue;
    },
    setCertificateDetailViewConfigurationAction(newValue) {
        if (this.debug) console.log('setCertificateDetailViewConfigurationAction triggered with', newValue)
        this.state.viewConfiguration.certificateDetail = newValue;
    }


    // clearMessageAction() {
    //     if (this.debug) console.log('clearMessageAction triggered')
    //     this.state.message = ''
    // }
}